<template>
    <div>
        
        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <!-- Add Item form -->       
        <button type="button" class="btn btn-primary" @click.prevent="showAddForm">+ Новая запись</button>
        <div class="modal fade" id="addForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Новая запись</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <div class="form-group">
                            <label for="name" class="col-form-label">Наименование:</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationAdd && errors.validationAdd.name">
                                {{ errors.validationAdd.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelAdding">Отмена</button>
                        <button type="button" class="btn btn-primary" @click.prevent="addRecord">Сохранить</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.add">
                        {{ errors.add }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Add Item form -->





        <!-- Edit Item form -->       
        <div class="modal fade" id="editForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Редактировать элемент # {{ id }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <input type="hidden" name="id" v-model="id">
                        <div class="form-group">
                            <label for="name" class="col-form-label">Наименование:</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationEdit && errors.validationEdit.name">
                                {{ errors.validationEdit.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelEditing">Отмена</button>
                        <button type="button" class="btn btn-primary" @click.prevent="editRecord(id)">Сохранить</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.edit">
                        {{ errors.edit }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Edit Item form -->

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <table class="table">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>Наименование</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                            <form @submit.prevent="deleteRecord(item.id)">
                                <button type="submit" class="btn btn-danger">Удалить</button>
                            </form>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary" @click.prevent="showEditForm(item)">Редактировать</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import jQuery from 'jquery'
import PageTitle from '@/components/PageTitle'
export default {
    data() {
        return {
            loading: true,
            data: [],
            id: 0,
            name: '',
            errors: {load: '', add: '', delete: '', edit: '', validationAdd: {}, validationEdit: {}},
            title: 'Список состояний глав',
        }
    },

   
   async mounted() {
       this.loadRecords()
    },
    methods: {

        clearErrors() {
            this.errors.load = '';
            this.errors.add = '';
            this.errors.delete = '';
            this.errors.edit = '';
        },

        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/chapterstates')
                this.data = response.data
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
        showAddForm() {
            this.name = ''
            this.errors.validationAdd = {}
            this.clearErrors();
            jQuery('#addForm').modal('show')
        },
        cancelAdding() {
            this.name = ''
            jQuery('#addForm').modal('hide')
        },
        //
        // Add new record.
        //
        async addRecord() {
            this.errors.validationAdd = {}
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapterstates', {name: this.name})
                if (response.status == 200) {
                    this.name = ''
                    this.loadRecords()
                    jQuery('#addForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationAdd = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.add = "Ошибка при создании записи."
                }
                else {
                    this.errors.add = "Неизвестная ошибка при создании записи."
                }
            }
        },
        //
        // Delete record.
        //
        async deleteRecord(id) {
            this.clearErrors();
            try {
                let response = await axios.delete('admin/chapterstates/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },




        showEditForm(item) {
            this.id = item.id
            this.name = item.name
            this.errors.validationEdit = {}
            this.clearErrors();
            jQuery('#editForm').modal('show')
        },
        cancelEditing() {
            this.name = ''
            jQuery('#editForm').modal('hide')
        },
        //
        // Edit record.
        //
        async editRecord(id) {
            this.errors.validationEdit = {}
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapterstates/'+id, {id: this.id, name: this.name, _method: 'PUT'})
                if (response.status == 200) {
                    this.id = 0
                    this.name = ''
                    this.loadRecords()
                    jQuery('#editForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationEdit = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.edit = "Ошибка при редактировании записи."
                }
                else {
                    this.errors.edit = "Неизвестная ошибка при редактировании записи."
                }
            }
        },



    },
    components: {
        Loader,
        PageTitle,
    }
}
</script>